/*
 * A crash used to look like a broken phone.
 *
 * With no boundary, a render-time exception leaves React's last painted frame
 * on screen and stops updating it: every button appears dead, and on a phone
 * there is no console to check. This says what happened, in one screen the
 * user can act on, and shows the message so it can be read off a screenshot.
 *
 * Deliberately plain: no hooks, no translation lookup, no context. It has to
 * work when the thing that failed might be any of those.
 */
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('IQ crashed:', error, info && info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const message = String((this.state.error && this.state.error.message) || this.state.error).slice(0, 300);
    return (
      <div
        role="alert"
        style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          gap: 14, padding: '24px max(16px, env(safe-area-inset-right)) 24px max(16px, env(safe-area-inset-left))',
          font: '15px/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          color: '#1d1d1f', background: '#f5f7f7', textAlign: 'center',
        }}
      >
        <strong style={{ fontSize: 17 }}>AquaNetica IQ stopped responding.</strong>
        <p style={{ margin: 0, maxWidth: 420 }}>
          Reloading usually fixes it. Your chats are saved on this device and are not affected.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            font: 'inherit', fontWeight: 600, padding: '12px 20px', minHeight: 44,
            borderRadius: 10, border: 'none', background: '#15807d', color: '#fff', cursor: 'pointer',
            touchAction: 'manipulation',
          }}
        >
          Reload
        </button>
        <code style={{ fontSize: 11, color: '#6e6e73', maxWidth: 420, wordBreak: 'break-word' }}>{message}</code>
      </div>
    );
  }
}
